import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CheckboxContainer,
  CustomCheckbox,
  HiddenCheckbox,
  IconIntermediate,
  IconChecked,
  IconUnchecked,
  IconDisabled
} from './styled';
import { CHECKED, UNCHECKED, INDETERMINATE, DISABLED } from './constants';

const Checkbox = props => {
  const { state, checkboxHandler, id } = props;
  const [currentState, setcurrentState] = useState(state);
  useEffect(() => {
    setcurrentState(state);
  }, [state]);

  const handleChange = () => {
    if (state === DISABLED) return;
    if (currentState === UNCHECKED || currentState === INDETERMINATE) {
      setcurrentState(CHECKED);
      checkboxHandler(CHECKED, id);
    } else {
      setcurrentState(UNCHECKED);
      checkboxHandler(UNCHECKED, id);
    }
  };
  return (
    <CheckboxContainer data-testid="checkbox-container" onClick={handleChange}>
      <HiddenCheckbox />
      <CustomCheckbox currentState={currentState}>
        {currentState === CHECKED && (
          <IconChecked data-testid="checked" viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </IconChecked>
        )}
        {currentState === UNCHECKED && (
          <IconUnchecked data-testid="unchecked" viewBox="0 0 24 24">
            <polyline points="0 0" />
          </IconUnchecked>
        )}
        {currentState === INDETERMINATE && (
          <IconIntermediate data-testid="indeterminate" viewBox="0 0 24 24">
            <polyline points="4 11 20 11 20 14 4 14 4 11" />
          </IconIntermediate>
        )}
        {currentState === DISABLED && (
          <IconDisabled data-testid="disabled" viewBox="0 0 24 24">
            <polyline points="0 0" />
          </IconDisabled>
        )}
      </CustomCheckbox>
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  state: PropTypes.string.isRequired,
  checkboxHandler: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Checkbox.defaultProps = {
  state: UNCHECKED,
  checkboxHandler: () => {},
  id: null
};

export default Checkbox;
